import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ErrorDialogData {
    message:string          // what the user is told
    details?:string         // technical details, for support
    unexpected?:boolean     // a fault rather than something the user can put right
    canReload?:boolean      // reloading the page is likely to fix it
}

// shows an error to the user. Further errors while it is open are counted rather than stacked
@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
    standalone: false
})
export class ErrorDialogComponent {
    moreErrors = 0
    showDetails = false
    copied = false

    constructor(@Inject(MAT_DIALOG_DATA) public data: ErrorDialogData) {}

    get title() {
        return this.data.unexpected ? 'Something went wrong' : "That couldn't be done"
    }

    async copyDetails() {
        try {
            await navigator.clipboard.writeText(`${this.data.message}\n\n${this.data.details || ''}`.trim())
            this.copied = true
        }catch(err) {
            // clipboard access can be refused; the details are still visible to copy by hand
            this.showDetails = true
        }
    }

    reload() {
        location.reload()
    }
}
